const ITEMS = [
  "WORLD",
  "BUSINESS",
  "TECH & AI",
  "SPORT",
  "ENTERTAINMENT",
  "SCIENCE & ENVIRONMENT",
  "PEOPLE & LIFESTYLE",
  "STORIES THAT MATTER",
  "TOLD OPENLY",
  "REAL STORIES. A BRIGHTER TOMORROW",
  "THEOPENTALE.COM",
];

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="relative overflow-hidden border-y border-white/5 bg-[#050b18] py-5"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="mx-8 whitespace-nowrap font-mono text-xs tracking-[0.35em] text-slate-400">{item}</span>
              <span className="text-cyan-400/80">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
